import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTestIDDirective, IntegerNumberDirective, InputTrimDirective, PreventDoubleClickDirective } from './directives';

@NgModule({
  declarations: [DataTestIDDirective, IntegerNumberDirective, InputTrimDirective, PreventDoubleClickDirective],
  exports: [DataTestIDDirective, IntegerNumberDirective, InputTrimDirective, PreventDoubleClickDirective],
  imports: [CommonModule],
})
export class CoreModule {}
